/**
 * @generated SignedSource<<c42757860f48f3063543b52e44ec1b51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type teamMemberDeleteInvitationMutation$variables = {
  id: string;
  connections: ReadonlyArray<string>;
};
export type teamMemberDeleteInvitationMutation$data = {
  readonly deleteTeamMemberInvitation: {
    readonly id: string;
  };
};
export type teamMemberDeleteInvitationMutation = {
  variables: teamMemberDeleteInvitationMutation$variables;
  response: teamMemberDeleteInvitationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "teamMemberDeleteInvitationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TeamMemberInvitationDeletePayload",
        "kind": "LinkedField",
        "name": "deleteTeamMemberInvitation",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "teamMemberDeleteInvitationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TeamMemberInvitationDeletePayload",
        "kind": "LinkedField",
        "name": "deleteTeamMemberInvitation",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16c26d0738a0a4871fc76c99d4879a71",
    "id": null,
    "metadata": {},
    "name": "teamMemberDeleteInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation teamMemberDeleteInvitationMutation(\n  $id: ID!\n) {\n  deleteTeamMemberInvitation(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "92cab8d919ad7734672bb5e6c85bad44";

export default node;
